<template>
  <Wysiwyg v-if="resource && $cms" class="empty-resource-notification">
    Die Komponente <strong>{{ resource.resource_class_name }}</strong> benötigt weitere Einstellungen/Inhalte, bitte bearbeiten Sie diese zunächst.
  </Wysiwyg>
</template>

<script>
import Wysiwyg from 'beisheim/components/elements/wysiwyg'

export default {
  components: {
    Wysiwyg
  },
  props: {
    resource: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="scss">
  .empty-resource-notification {
    padding: 1rem;
    text-align: center;
    background: yellow;
  }
</style>
